(function Excursions($, Adzuki)
{
	"use strict";

	var Excursions = {};

	var $modal                 = $(".modal");
	var modal_selections_saved = false;
	var edit_mode              = false;          // if true, we will save to db via ajax upon save button click
	var model                  = 'CruiseSheet';  // controls where we will save via ajax

	$(document).ready(function documentReady()
	{
		// user clicks to see more info about an excursion. To get all available excursion details, we need to make an API call
		// this was originally in "js\Erez\cruise_search\results.js", but this functionality needed to be centralized because, it
		// gets used elsewhere
		$(document).on('click', '.excursion-more-info', function excursionMore(e) {
			var $self          = $(this),
			    $ani           = $self.find('.exc-loader'),
			    excursion_code = $self.data('excursion-code'),
			    $table         = $self.find('.well').find('.table'),
			    populated      = $table.attr('data-populated');

			// check to see if we already made an ajax call to get the excursion details
			if (populated !== '0') {
				return;
			}

			Adzuki.Ajax.get('/Excursions/getByCode/' + excursion_code)
				.then(function _showExcursionDeets(json) {
					var rows,
					    arr = {};

					if (json) {
						arr = {
								Description        : json.description,
								"Private Tour"     : (json.private_tour === true) ? 'Y' : 'N',
								Code               : json.code,
								Size               : json.features.size,
								Type               : json.features.type,
								"Departs From"     : json.features.departs_from,
								"Activity Level"   : json.features.activity_level,
								"Food & Beverage"  : json.features.food_beverage,
								"Recommended Dress": json.features.recommended_dress,
								Restrictions       : json.features.restrictions
						};

						$.each(arr, function detailsLoop( index, value ) {
							if (value !== undefined) {
								rows += '<tr><td class="col-sm-3 text-right"><b>' + index + '</b>:</td><td>' + value + '</td></tr>';
							}
						});
					} else {
						rows += '<tr><td class="col-sm-12" colspan="2">Additional Excursion Details Currently Unavailable</td></tr>';
					}

					$table.find('> tbody').append(rows);
					$table.attr('data-populated', '1');
					$ani.hide();
			});
		});

		if ($(".specific-excursion-link").length > 0) {

			// opening the modal in order to start selecting specific excursions
			// $('.specific-excursion-link').click(function chooseSpecificExcursions(e) {
			$(document).on('click', '.specific-excursion-link', function chooseSpecificExcursions(e) {
				var $self               = $(this),
					unique_id           = $self.data('unique-id'),
					selected_excursions = $('#' + unique_id + '_selected_excursions').val();  // field defined on add (for each itin) or edit screens

				e.preventDefault();

				modal_selections_saved = false;

				if ($self.hasClass('edit-mode')) {
					edit_mode = true;
				}

				model = $self.data('model');

				// add mode, we made some selections, closed the modal and are coming back to edit selections some more
				if ( (edit_mode === false) && (selected_excursions.locations) ) {

					// get array of excursion codes only
					selected_excursions = getExcursionCodesOnlyFromLocationsArr(JSON.parse(selected_excursions.locations));

					// make array JSON
					selected_excursions = JSON.stringify(selected_excursions);
				}

				populateExcursionsModal($self, selected_excursions);
			});

			// viewing excursions by city
			$(document).on('click', '.excursion-panel .show-location', function showHideLocations(e) {
				var location = $(this).data('location');
				e.preventDefault();

				// clicked location is active
				$(this).addClass('active');

				// other locations not active
				$(this).siblings().each(function removeActive() {
					$(this).removeClass('active');
				});

				// hide other location excursions
				$('.excursion-locations').each(function hideLocations() {
					$(this).css('display', 'none');
				});

				// show this location's excursions
				$('#location-' + location).fadeIn();

				// scroll back to the top of the location's content
				$(".excursions-container").scrollTop(0);
			});

			// clicking on an excursion
			$(document).on('click', '.excursions-container .excursions .excursion', function selectItem(e) {
				var code           = $(this).data('code'),
					location_code  = $(this).data('location-code'),
					$code_el       = $('#code-' + code),
					selected_excursions,
					selected_count;

				e.preventDefault();

				// remove selection
				if ($code_el.hasClass('excursion-selected')) {
					$code_el.removeClass('excursion-selected');

					adjustLocationCount(location_code, 'subtract');

				// add selection
				} else {
					$code_el.addClass('excursion-selected');
					adjustLocationCount(location_code, 'add');
				}

				selected_excursions = excursionsSelected();
				selected_count      = selected_excursions.length;

				$('.selected-items-count').html(selected_count);

				toggleSaveButton();
			});

			// clicking the save button in the modal
			$(document).on('click', '.save-button', function saveExcursions(e) {
				e.preventDefault();
				saveModalSelections();
			});

			// clear out excursions for itinerary
			$(document).on('click', '.excursion-panel .clear-button', function clearExcursions(e) {
				var $selected = excursionsSelected();

				e.preventDefault();

				// replicate "un-selecting" clicks for each
				$selected.each(function codesArr() {
					$(this).trigger( "click" );
				});

				// saveModalSelections();

				// Adzuki.StatusMessage('Success', 'Specific excursions cleared.');
			});

			// select all excursions for itinerary
			$(document).on('click', '.excursion-panel .select-all-button', function selectAllEx(e) {
				e.preventDefault();

				// clear all first, because selectAllExcursions() simulates a click, so it would toggle already selected ones if we don't clear first
				$('.excursion-panel .clear-button').trigger( "click" );

				selectAllExcursions();
			});

			// user attempting to close modal. remind them to click save button
			$modal.on("hide.bs.modal", function itsClosing() {
				var selected = excursionsSelected();

				if ( (selected.length > 0) && (modal_selections_saved === false) ) {
					// Adzuki.StatusMessage('Error', 'Make sure to click "Save All Selections" in order for your excursions to be saved.');

					Adzuki.CustomConfirm({
						content: 'Any changes to shore excursion selections have not been saved. Are you sure you wish to close the window before clicking the "Save All Selections" button?',
						confirm: function confirm() {
							modal_selections_saved = true;
							$modal.modal('hide');
						}
					});

					return false;
				}
			});

			// deleting an excursion from a cruise component
			$(document).on('click', '.delete-cruise-excursion', function deleteExcursion(e) {
				var $self                    = $(this),
					id                       = $self.data('id'),
					reservation_component_id = $self.data('component-id');

				e.preventDefault();

				Adzuki.CustomConfirm({
					content: 'Are you sure you wish to remove this selected excursion?',
					confirm: function confirm() {
						Adzuki.Ajax.get('/ReservationCruiseComponentExcursions/delete/' + id)
							.then(function deleteEx(json) {
								if (json.status === true) {
									Adzuki.StatusMessage('Success', 'Excursion removed.');
									reloadReservationExcursions(reservation_component_id);
								} else {
									Adzuki.StatusMessage('Error', 'Excursion could not be removed. It may be due to insufficient permissions.');
								}
							}
						);
					}
				});
			});

			// pull in excursion details from ShoreTrips and show in modal
			$(document).on('click', '.view-excursion-details', function viewExcursion(e) {
				var $self = $(this),
				    code  = $self.data('code'),
				    name  = $self.data('name');

				e.preventDefault();

				$modal.find('.modal-title').text(name + ' Details');
				$modal.find('.modal-body').html('<i class="'+Adzuki.FaIcon.getIconStyle('spinner')+' fa-spin fa-2x"></i>&nbsp;Loading Excursion...');

				Adzuki.Ajax.get('/Itineraries/excursionView/' + code)
				.then(function _showExcursionsForms(html) {
					$modal.find('.modal-body').html(html);
				});

				$modal.on('hidden.bs.modal', function _restoreModal() {
					$modal.removeClass('wide').off('hidden.bs.modal');
				}).modal('show');

			});

			// user wants to select all excursions for a city
			$(document).on('click', '.select-all-city', function selectAllLocation(e) {
				var $self                = $(this),
				    $location_excursions = $self.closest('.excursion-locations').find('.excursion').not(".excursion-selected");

				e.preventDefault();

				$location_excursions.each(function locationSelected() {
					$(this).trigger( "click" );
				});
			});

			// user wants to de-select all excursions for a city
			$(document).on('click', '.remove-all-city', function removeAllLocation(e) {
				var $self                = $(this),
				    $excursions_selected = $self.closest('.excursion-locations').find('.excursion-selected');

				e.preventDefault();

				$excursions_selected.each(function locationUnselected() {
					$(this).trigger( "click" );
				});
			});
		}
	});

	// before closing the modal, find whatever excursions are selected, put the codes into JSON string, and put in hidden form field for this itinerary for posting purposes
	function saveModalSelections()
	{
		var $excursions_selected = excursionsSelected(),
		    $unique_field        = $('#selected-unique-id'),
		    unique_id            = $unique_field.val(),
		    $excursion_count     = $('#' + unique_id + '-excursion-count'),
		    show_count           = $excursion_count.data('display-count'),
		    $field               = $('#' + unique_id + '_selected_excursions'),
		    all_locations        = getAllLocationsPostData($excursions_selected),
		    excursion_codes      = getExcursionCodesOnlyFromLocationsArr(all_locations),
		    hidden_val           = {};

		hidden_val['locations'] = all_locations;

		// set form field for itinerary for posting purposes
		$field.val(JSON.stringify(hidden_val));

		// showing count of excursions for the itinerary after the modal is closed
		if ((excursion_codes.length > 0) && (show_count === 1)) {
			$excursion_count.removeClass('hidden');
			$excursion_count.html(' (' + excursion_codes.length + ' selected)');
		} else {
			$excursion_count.addClass('hidden');
		}

		// set to true to avoid warning popping up on modal close
		modal_selections_saved = true;

		// in edit mode, we can save to the DB immejiately
		if (edit_mode === true) {

			if (model === 'CruiseSheet') {
				cruiseSheetDbSave($excursions_selected);
			}

			if (model === 'ReservationCruiseComponent') {
				cruiseComponentDbSave(unique_id, $excursions_selected);
			}
		}

		$modal.modal('hide');
	}

	// adjust the badge count of selected excursions for each city/location in modal
	function adjustLocationCount(location_code, operation)
	{
		var $el   = $("#" + location_code + "-location-count"),
			value = parseInt($el.html());

		if (operation === 'add') {
			value++;
		} else {
			value--;
		}

		$el.html(value);
	}

	// save to db for cruise reservations
	function cruiseComponentDbSave(reservation_component_id, $excursion_elements)
	{
		var postdata      = {},
		    all_locations = getAllLocationsPostData($excursion_elements);

		postdata.reservation_cruise_component_id = reservation_component_id;
		postdata.locations                       = all_locations;

		// update the DB
		Adzuki.Ajax.post('/ReservationCruiseComponentExcursions/save/', postdata)
			.then(function saveExcursions(json) {
				if (json.status === true) {
					Adzuki.StatusMessage('Success', 'Excursion selections saved.');
					reloadReservationExcursions(reservation_component_id);
				} else {
					Adzuki.StatusMessage('Error', 'Excursion selections could not be saved.');
				}
			}
		);
	}

	// save to db for cruise sheets
	function cruiseSheetDbSave($excursion_elements)
	{
		var postdata      = {},
		    all_locations = getAllLocationsPostData($excursion_elements);

		postdata.cruise_sheet_id = $('#cruisesheetprepare-id').val();
		postdata.locations       = all_locations;

		// update the DB
		Adzuki.Ajax.post('/CruiseSheets/saveExcursions/', postdata)
			.then(function saveExcursions(json) {
				if (json.status === true) {
					Adzuki.StatusMessage('Success', 'Excursion selections saved.');

					// this will refresh the table of existing selected excursions on the edit cruise sheet screen
					Adzuki.Ajax.get('/CruiseSheets/refreshExcursions/' + postdata.cruise_sheet_id)
					.then(function _refreshEx(html) {
						$('#excursion-summary').html(html);
					});

				} else {
					Adzuki.StatusMessage('Error', 'Excursion selections could not be saved.');
				}

				// reload iframe preview
				$('#cruise-sheets-preview').attr("src", $('#cruise-sheets-preview').attr("src"));
		});
	}

	// returns all excursion elements currently selected within the modal
	function excursionsSelected()
	{
		var $parent   = $('.excursions-container'),
		    $selected = $parent.find('.excursion-selected');

		return $selected;
	}

	// all of the locations from Shoretrips for the itinerary that have excursions
	function getAllLocationCodes()
	{
		var $locations = $('.excursion-panel').find('.list-group').find('.list-group-item'),
		    output     = {};

		$locations.each(function locationCodes() {
			var $self               = $(this),
			    code                = $self.data('location'),
			    name                = $self.data('name'),
			    max_excursion_count = parseInt($('#' + code + '-location-possible-count').html());

			output[code] = {
				name               : name,
				max_excursion_count: max_excursion_count,
				excursions         : []
			};
		});

		return output;
	}

	// data to post for all ports
	function getAllLocationsPostData($excursion_elements)
	{
		var all_locations = getAllLocationCodes();

		$excursion_elements.each(function excursionArr(i, element) {
			var $self         = $(this),
			    location_code = $self.data('location-code');

			all_locations[location_code].excursions.push({
				code    : $self.data('code'),
				category: $self.data('category'),
				name    : $self.data('excursion-name')
			});
		});

		return all_locations;
	}

	// extract only excursion codes from the array of location data
	function getExcursionCodesOnlyFromLocationsArr(locations)
	{
		var output = [];

		$.each( locations, function loop( key, loc ) {
			$.each( loc.excursions, function loop( i, ex ) {
				output.push(ex.code);
			});
		});

		return output;
	}

	// figures out which excursions to click for a location on edit
	function handlePrepopulateLocation(obj)
	{
		$.each( obj, function loop( key, loc ) {
			var $loc_container = $('#location-' + loc.code),
			    $excursions    = $loc_container.find('.excursion');

			// everything for a location should be selected
			if (loc.all_selected === '1') {

				$excursions.each(function locationSelected() {
					$(this).trigger( "click" );
				});
			}

			if (loc.excursions.length > 0) {
				$.each( loc.excursions, function loop( ex_key, ex ) {
					$("#code-" + ex.code).trigger( "click" );
				});
			}
		});
	}

	function populateExcursionsModal($link, selected_excursions)
	{
		var ship_id      = $link.data('ship-id'),
		    sailing_date = $link.data('sailing_date'),
		    unique_id    = $link.data('unique-id'),
		    num_nights   = $link.data('num_nights'),
		    url          = '/Itineraries/excursionSelection/' + ship_id + '/' + sailing_date + '/' + unique_id + '/' + num_nights;

		if (typeof $link.data('excursion-company') !== 'undefined') {
			url += '/' + $link.data('excursion-company');
		}

		$modal.find('.modal-title').text('Available Shore Excursions');
		$modal.find('.modal-body').html('<i class="' + Adzuki.FaIcon.getIconStyle('spinner') + ' fa-spin fa-2x"></i>&nbsp;Loading Excursions...');

		// pull in excursion options
		Adzuki.Ajax.get(url)
		.then(function _showExcursionsForms(html) {
			$modal.find('.modal-body').html(html);

			if (selected_excursions.length > 0) {
				// trigger click for all of the excursions already selected
				toggleJsonExcursions(selected_excursions);

				// should enable the save button in this circumstance
				toggleSaveButton();
			} else {
				selectAllExcursions();
			}
		});

		$modal.on('hidden.bs.modal', function _restoreModal() {
			$modal.removeClass('wide').off('hidden.bs.modal');
		}).modal('show');
	}

	function reloadReservationExcursions(reservation_component_id)
	{
		var $container = $('#' + reservation_component_id + '-excursion-container');

		// reload table
		$container.html('<i class="'+Adzuki.FaIcon.getIconStyle('spinner')+' fa-spin fa-2x"></i>&nbsp;Loading Excursions...');

		Adzuki.Ajax.get('/ReservationCruiseComponentExcursions/showTable/' + reservation_component_id )
		.then(function _reloadTable(table) {
			$container.html(table);
		});
	}

	// select every excursion
	function selectAllExcursions()
	{
		var $locations = $('.excursion-locations').find('.excursion');

		$locations.each(function checkNoSelected() {
			var $self = $(this);

			$self.trigger( "click" );
		});
	}

	// as if the user toggled an array of excursions. Allows us to pre-select excursions on edit or if the user edits in the modal multiple times
	// before hitting save during the add process
	function toggleJsonExcursions(json_val)
	{
		var arr = JSON.parse(json_val);

		$.each( arr, function loop( key, value ) {
			if (key === 'locations') {
				handlePrepopulateLocation(value);
			} else {
				$("#code-" + value).trigger( "click" );
			}
		});
	}

	// determines whether the save button should be enabled or disabled
	function toggleSaveButton()
	{
		var selected_count = excursionsSelected().length;

		// enable
		if (selected_count > 0) {
			$('.save-button').removeClass('disabled');
			$('.save-button').attr('disabled', false);

		// disable
		} else {
			$('.save-button').addClass('disabled');
			$('.save-button').attr('disabled', true);
		}
	}

	Adzuki.Excursions = Excursions;

}(jQuery, window.Adzuki || {}));
